import React, { Component } from "react";
import { translate } from '../Services/translation';
import { connect } from 'react-redux';
import BahagCustomerInfoForm from "./CustomerPersonaForm";
import BahagSignIn from "./BahagSignIn";
import BahagForgetPassword from "./BahagForgetPassword";
import BahagConfirmeResetEmail from "./BahagConfirmResetEmail";
import BahagSignUp from "./BahagSignUp";
import BahagLoggedin from "./BahagLoggedin";
import BahagDelivery from "./BahagDelivery";
import BahagErrorModal from "./BahagErrorModal";
import { setAuthorizationHybris, showConfirmLogin, showBahagSignIn, showBahagSignUp, login, setCustomerInfo, activeSignInSection, getCustomerSession } from '../actions/Bahag.action';
import { getCookie } from "../Components/AB-test-read-more";
import Loader from "./Loader";

class GermanyContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            toLogin: false,
            toCustomerInformation: false,
            forgetPasswordEmail: "",
        };
    }

    handleChange(event) {
        const { name, value } = event.target;
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
    }

    //If the Cookie exist so no need to login again. 
    async checkUserLoginSession() {
        const authorizationHybrisFromCookie = await getCookie("authorizationHybris");
        if (authorizationHybrisFromCookie && authorizationHybrisFromCookie !== "") {
            const customerInfo = await this.props.getCustomerSession(authorizationHybrisFromCookie);

            if (customerInfo) {
                await this.props.setCustomerInfo(customerInfo);
                await this.props.activeSignInSection(false);
                await this.props.showConfirmLogin(true);
                await this.props.setAuthorizationHybris(authorizationHybrisFromCookie);
            }
        }
    }

    //Parent Section
    renderLogInSignup() {
        this.checkUserLoginSession();
        return (
            <>
                <div className={!this.props.isSignInSectionActive ? "germany-section--inactive germany-section__container" : "germany-section__container"}>
                    {this.props.isShowBahagConfirmLogin && <BahagLoggedin />}
                    {this.props.isShowBahagSignIn && <BahagSignIn />}
                    {this.props.isShowBahagSignUp && <BahagSignUp />}
                    {this.props.isShowBahagForgetPassword && <BahagForgetPassword />}
                    {this.props.isShowBahagConfirmSentEmail && <BahagConfirmeResetEmail />}
                    <div className='germany-checkout-cartArrow'></div>
                </div>
            </>
        )
    }

    render() {
        let selectedReseller = this.props.selectedReseller;
        const bahagResller = "bahag";
        const isAnyProductNotAvailable = this.props.orderRowsWithStock.some(item => !item.available);

        return (
            <div id="bahagSections" className={`${selectedReseller === bahagResller && !isAnyProductNotAvailable ? 'bahag-show' : 'bahag-hide'}`}>
                {this.props.isLoaderActive && < Loader />}
                {this.props.bahagErrorModal && < BahagErrorModal />}
                {this.renderLogInSignup()}
                {<div className={!this.props.isActiveDeliverySection ? "germany-section--inactive" : ""}> <BahagDelivery /> </div>}
                {<div className={!this.props.isActiveCustomerAddress ? "germany-section--inactive" : ""}> <BahagCustomerInfoForm /> </div>}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isShowBahagSignIn: state.bahag.payload.isShowBahagSignIn,
        isShowBahagSignUp: state.bahag.payload.isShowBahagSignUp,
        isShowBahagForgetPassword: state.bahag.payload.isShowBahagForgetPassword,
        isShowBahagConfirmSentEmail: state.bahag.payload.isShowBahagConfirmSentEmail,
        isShowBahagConfirmLogin: state.bahag.payload.isShowBahagConfirmLogin,
        isActiveCustomerAddress: state.bahag.isActiveCustomerAddress,
        isActiveDeliverySection: state.bahag.isActiveDeliverySection,
        isSignInSectionActive: state.bahag.isSignInSectionActive,
        bahagErrorModal: state.bahag.bahagErrorModal,
        isLoaderActive: state.bahag.isLoaderActive,
        selectedReseller: state.bahag.selectedReseller,
        orderRowsWithStock: state.bahag.orderRowsWithStock
    };
};

const mapDispatchToProps = (dispatch) => ({
    showConfirmLogin: () => dispatch(showConfirmLogin(true)),
    showBahagSignIn: () => dispatch(showBahagSignIn(true)),
    showBahagSignUp: () => dispatch(showBahagSignUp(true)),
    login: (email) => dispatch(login(email)),
    getCustomerSession: (customerId) => dispatch(getCustomerSession(customerId)),
    activeSignInSection: () => dispatch(activeSignInSection(true)),
    setCustomerInfo: (customerInfo) => dispatch(setCustomerInfo(customerInfo)),
    setAuthorizationHybris: (authorizationHybris) => dispatch(setAuthorizationHybris(authorizationHybris))
});

export default connect(mapStateToProps, mapDispatchToProps)(GermanyContainer);
